/** @format */
import Cookie from 'js-cookie'
import dayjs from 'dayjs'
import { ExportHeaders } from './interface'

// 获取当前语言环境
export const getCurrentLang = () => {
  const lang = Cookie.get('ksc_lang')
  const enDict = window['monitor_lang_dict_en']
  const zhDict = window['monitor_lang_dict_zh']
  switch (lang) {
    case 'zh':
      return zhDict
    case 'en':
      return enDict
    default:
      return
  }
}

// 页面调用文档显示方法
export const SetDocumentFn = (customUrl: string) => {
  const ksStorage = window['__ksStorage__']
  if (ksStorage && ksStorage.docSet) {
    ksStorage.docSet({
      // 中文地址（非必填，不传该参数时打开的是文档弹层首页）
      indexUrl: `//docs.ksyun.com/documents/${customUrl}`,
      // 英文地址（非必填，不传该参数时打开的是文档弹层首页）
      indexEnUrl: `//endocs.ksyun.com/documents/${customUrl}`,
      // 设置文档的z-index，（非必填，不传该参数时默认是2000）
      zIndex: 10000
    })
  } else {
    console.log('window对象')
  }
}
// 处理region list
export const _processRegion = monitorRegionList => {
  const localSysId = monitorRegionList?.length ? monitorRegionList[0].regionKey : ''
  //查看缓存的是否在数据里
  // monitorRegionList.forEach(function (item) {
  //   if (item.regionKey === localStorage.systemId) {
  //     localSysId = localStorage.systemId
  //   }
  // })
  // localSysId = localSysId ? localSysId : monitorRegionList[0].regionKey
  localStorage.systemId = localSysId
  console.log('ksstorage', window?.['__ksStorage__'])
  window?.['__ksStorage__']?.setValue('region', localSysId)
}
// 判断数据类型
export const getDataType = data => {
  return Object.prototype.toString.call(data).slice(8, -1)
}

// 最多保留两位小数
export const keepDecimal = (num: number | string, int?: boolean): number => {
  const result = parseFloat(num + '')
  if (isNaN(result)) {
    return 0
  }
  if (int && result > 100) {
    return Math.ceil(result)
  } else if (int && result > 10) {
    return Math.round(result * 10) / 10
  } else {
    return Math.round(result * 1000) / 1000
  }
}

// 1024转换的单位
export const unitFormatBps = unit => {
  const includeArr = [
    'B',
    'KB',
    'MB',
    'GB',
    'Bps',
    'KBps',
    'GBps',
    'MBps',
    'Byte',
    'MBytes',
    'Byte/秒',
    'Bytes/s',
    'B/s',
    'kB/s',
    'KB/s',
    'MB/s',
    'B/sec',
    'B/秒',
    'kB/秒',
    'KB/秒',
    'MB/秒'
  ]
  return includeArr.includes(unit)
}

// 1000转换的单位
export const unitFormatbps = unit => {
  const includeArr = [
    'b',
    'Kb',
    'Mb',
    'Gb',
    'bps',
    'Kbps',
    'Gbps',
    'Mbps',
    'bit',
    'Kbit',
    'bit/秒',
    'Mbit/秒',
    'bit/s',
    'Mbit/s',
    'b/s',
    'kb/s',
    'Kb/s',
    'Mb/s',
    'b/sec',
    'b/秒',
    'kb/秒',
    'Kb/秒',
    'Mb/秒',
    'pps',
    'Kps',
    'Gps'
  ]
  return includeArr.includes(unit)
}

// pps转换
export const unitFormatpps = unit => {
  const includeArr = ['pps', 'Kps', 'Gps']
  return includeArr.includes(unit)
}

export const unitFormatMs = (value, unit) => {
  const unitArr = ['μs', 'ms', 's']
  if (value < 1000 || unit === 's') {
    return `${keepDecimal(value)}${unit}`
  } else {
    let index = unit === 'us' ? 0 : unitArr.indexOf(unit)
    while (value / 1000 >= 1 && index < 2) {
      value = value / 1000
      index += 1
    }
    return `${keepDecimal(value)}${unitArr[index]}`
  }
}

// 进制转换（B、Bps、b、bps）
export const bytesSymbols = ['K', 'M', 'G', 'T', 'P', 'E']
export const unitFormat = (
  value: number,
  base: 1024 | 1000,
  units?: string,
  int?: boolean
): string => {
  if (value < base) {
    return `${keepDecimal(value, int)}${units || ''}`
  } else {
    let index = -1
    if (units && units !== 'pps') {
      index = bytesSymbols.indexOf(units[0].toUpperCase())
    }
    let u = units || ''
    if (index >= 0 || units === 'pps') {
      u = units.slice(1)
    }
    while (value / base >= 1) {
      value = value / base
      index += 1
    }
    // 去除掉/s 、 /秒
    const sIndex = u.indexOf('/s') || u.indexOf('/秒')
    if (int && sIndex > 0) {
      u = u.substring(0, sIndex)
    }
    return `${keepDecimal(value, int)}${bytesSymbols[index] || ''}${u}`
  }
}

// 单位转换
export const handleUnit = (value, units, int?) => {
  if (value === 'N/A') return value
  if (value === null || value === undefined) return '-'
  if (unitFormatBps(units)) {
    return unitFormat(value, 1024, units, int)
  } else if (unitFormatbps(units)) {
    return unitFormat(value, 1000, units, int)
  } else if (['pps', 'Kps', 'Gps'].includes(units)) {
    return unitFormat(value, 1000, units, int)
  } else if (['μs', 'us', 'ms', 's'].includes(units)) {
    return unitFormatMs(value, units)
  } else {
    if (value > 99999999999) {
      return `${keepDecimal(value / 100000000000, int)}千亿${units || ''}`
    } else if (value > 99999999) {
      return `${keepDecimal(value / 100000000, int)}亿${units || ''}`
    } else if (value > 9999) {
      return `${keepDecimal(value / 10000, int)}万${units || ''}`
    } else if (value > 999) {
      return `${keepDecimal(value / 1000, int)}千${units || ''}`
    }
    return `${keepDecimal(value, int)}${units || ''}`
  }
}
// 计算Y轴最大最小值
export const formatInt = (num, ceil = true) => {
  const len = String(Math.trunc(num)).length
  if (len <= len - 2) {
    return num
  }
  const mult = Math.pow(10, len - 2)
  const result = ceil ? Math.ceil(num / mult) * mult : Math.floor(num / mult) * mult
  return result
}

// 处理tooltip
export const tooltipFormatter = (params, u?, clickfn?) => {
  // eslint-disable-next-line max-len
  let content = `<div class='chart-tooltip'><p class="chart-tooltip-title" >${params[0]?.axisValue}</p>`
  params.forEach(item => {
    const { seriesName, value, marker, data } = item
    const [name, unit] = seriesName.split('===')
    const calcValue = handleUnit(value, u || unit) || '-'
    content += `<div class="chart-tooltip-item">
      <div class="chart-tooltip-item-name" >
        <div class="chart-tooltip-item-name-marker">${marker}</div>
        <p class="chart-tooltip-item-name-text text-overflow">${name}</p>
      </div>
      <p class="chart-tooltip-item-value">${calcValue} ${
      data?.null_data?.length && clickfn
        ? // eslint-disable-next-line max-len
          `<span class="chart-tooltip-item-null" onclick="console.log('123')">(${data?.null_data.length})</span>`
        : ''
    }</p>
    </div>`
  })
  return content
}

// 获取父iframe的url
export const getParentUrl = () => {
  let url = ''
  if (window.parent !== window) {
    try {
      url = window.parent.location.href
    } catch (e) {
      url = document.referrer
    }
  }
  return url
}

// 生成十六进制随机数
export const getRamNumber = (count = 16) => {
  let result = ''
  for (let i = 0; i < count; i++) {
    result += Math.floor(Math.random() * 16).toString(16) //获取0-15并通过toString转16进制
  }
  return result.toLowerCase() //另转小写
}

// 错误状态处理
export const interfaceMessage = errorType => {
  switch (errorType) {
    case 'Unauthorized':
      return '账户未授权'
    case 'MissingToken':
      return `请求 Header 中缺少 'X-Auth-Token' 参数。`
    case 'InvalidToken':
      return `解析 'X-Auth-Token' 没有解析出 tenantId。`
    case 'InvalidParameter':
      return '绑定请求参数错误，可能值类型不正确。'
    case 'TrimSpaceParameter':
      return '去除请求参数中多余的空字符错误。'
    case 'MissingParameter':
      return '参数不能空。'
    case 'ServiceUnavailable':
      return '服务异常。'
    case 'ServiceException':
      return '主要数据库的错误。'
    case 'NotFoundRegion':
      return '没有对应的IDC机房。'
    case 'RegionUnavaliable':
      return '监控的IDC在转换的时候出现错误。'
    case 'AccountNotFound':
      return '没有找到对应的账户信息。'
    case 'InvalidProductType':
      return '传入的产品线或者业务中涉及的产品类型不存在。'
    case 'NotSupportProject':
      return '传入的产品线不支持项目制(目前创建策略中使用)'
    case 'NotAllowProductType':
      return '产品线不支持此类操作'
    case 'NotFoundInstance':
      return '没有找到对应的实例资源。'
    case 'AccountHasNoInstances':
      return '当前客户没有实例资源。'
    case 'NotFoundInstanceMetric':
      return '根据实例没有找到所对应的监控项。'
    case 'NonAggregateInstance':
      return '当前实例为非聚合实例。'
    case 'InconsistentInstancePType':
      return '参数中的产品类型和实例的所对应的类型不相同。'
    case 'InvalidMetricPeriod':
      return '设置的采集周期不合法'
    case 'NotFoundSysEventType':
      return '没有找到对应的系统事件类型。'
    case 'ExistSysEventType':
      return '当前系统事件类型已存在。'
    case 'CreateSysEventTypeFailed':
      return '创建事件类型失败。'
    case 'ModifySysEventTypeFailed':
      return '修改事件类型失败。'
    case 'DeleteSysEventTypeFailed':
      return '删除事件类型失败。'
    case 'SysEventTypeHasOwnEvent':
      return ''
    case 'ExistSysEventName':
      return '事件名称已存在。'
    case 'NotRegularEventName':
      return '系统事件名称不符合规范。'
    case 'InvalidSysEventLevel':
      return '无效的系统事件等级'
    case 'NotFoundSysEvent':
      return '没有找到对应的系统事件'
    case 'SysEventHasOwnRules':
      return ''
    case 'CreateSysEventFailed':
      return '创建事件失败'
    case 'ModifySysEventFailed':
      return '修改事件失败'
    case 'DeleteSysEventFailed':
      return '删除事件告警失败'
    case 'EnableSysEventFailed':
      return '启用事件失败'
    case 'DisableSysEventFailed':
      return '禁用事件失败。'
    case 'ExistSysEventWhitelist':
      return '账户的白名单已存在。'
    case 'NotFoundSysEventWhitelist':
      return '未找到与指定账户相关系统事件白名单产品。'
    case 'NotFoundEventPolicy':
      return '没有找到对应事件告警策略。'
    case 'MissingEventPolicyName':
      return '事件告警策略名称不能为空。'
    case 'NotRegularEventPolicyName':
      return '无效事件告警策略名称。'
    case 'InvalidEventPolicyType':
      return '无效事件告警策略类型。'
    case 'ExceedsLimitCallback':
      return 'The number of callback addresses exceeds the limit.'
    case 'InvalidEventPolicyContactWay':
      return '告警联系人中联系方式无效。'
    case 'InvalidEventPolicyContactFlag':
      return '告警联系人中联系标识无效，用来区分联系组合联系人。'
    case 'InvalidEventPolicyContactName':
      return '告警联系人中联系人姓名无效。'
    case 'MissingEventPolicyBindInsGrp':
      return '没有选择待绑定的实例组。'
    case 'CreateEventPolicyFailed':
      return '创建事件告警策略失败。'
    case 'ModifyEventPolicyFailed':
      return '修改事件告警策略失败。'
    case 'DeleteEventPolicyFailed':
      return '删除事件告警策略失败。'
    case 'EnableEventPolicyFailed':
      return '启用事件告警策略失败。'
    case 'DisableEventPolicyFailed':
      return '禁用事件告警策略失败。'
    case 'NotRegularPolicyName':
      return '阈值告警策略名称不规范。'
    case 'EmptyTriggerRules':
      return '阈值触发规则不能为空'
    case 'InvalidPeriod':
      return '无效的采集周期'
    case 'InvalidMethod':
      return '无效的统计方式'
    case 'InvalidCompare':
      return '无效的比较方式'
    case 'ExistsDefaultPolicy':
      return '传入的产品线已存在默认策略。'
    case 'CreatePolicyFailed':
      return '创建阈值告警策略失败。'
    case 'CreateTriggerRuleFailed':
      return '创建阈值告警触发规则失败。'
    case 'InvalidResourceBind':
      return '无效的资源绑定类型。'
    case 'EmptyBindResource':
      return '策略绑定自选实例不能为空'
    case 'IncorrectBindResource':
      return '绑定的实例资源数不一致'
    case 'NotFoundPolicy':
      return '未找到对应阈值告警策略'
    case 'ParseException':
      return 'MQ 解析失败'
    case 'FailedRemoteProject':
      return '根据账户信息获取IAM下的项目列表失败'
    case 'ConditionTemplateHasReferenced':
      return '该告警模板已关联告警策略，请先解除关联告警策略或删除告警策略，再删除该模板！'
    default:
      return undefined
  }
}
// 前端导出数据
export const handleExportForm = (headers: ExportHeaders[], dataSource, fileName) => {
  //列标题，逗号隔开，每一个逗号就是隔开一个单元格
  let str = ''

  const headerValues = headers.map(i => {
    return i.value.replaceAll(',', ';')
  })
  str += headerValues.join(',')
  str += '\n'
  //增加\t为了不让表格显示科学计数法或者其他格式
  for (let i = 0; i < dataSource.length; i++) {
    str += `${dataSource[i]}\t`
    str += '\n'
  }
  //encodeURIComponent解决中文乱码
  const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
  //通过创建a标签实现
  const link = document.createElement('a')
  link.href = uri
  //对下载的文件命名
  const date = new Date()
  const dateNow = dayjs(date).format('YYYY-MM-DD HH-mm-ss')
  link.download = `${fileName}_${dateNow}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// params首字母大写/小写
export const handleParamsCase = (params, to: 'upper' | 'lower' = 'upper') => {
  switch (getDataType(params)) {
    case 'Object':
      const obj = {}
      for (const key in params) {
        const result =
          to === 'upper' ? key.slice(0, 1).toLocaleUpperCase() : key.slice(0, 1).toLocaleLowerCase()
        const newKey = result + key.slice(1)
        obj[newKey] = handleParamsCase(params[key], to)
      }
      return obj
    case 'Array':
      const arr = []
      params.forEach(item => {
        arr.push(handleParamsCase(item, to))
      })
      return arr
    default:
      return params
  }
}

// Base64解码（用于示例字段）
export const debase64 = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return ''
  }
  // 检查是否是Base64编码（Base64只包含 A-Z, a-z, 0-9, +, /, =）
  const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/
  if (base64Regex.test(str) && str.length > 10) {
    try {
      const decoded = atob(str)
      // 检查解码后的内容是否包含可打印字符（至少包含一些字母）
      if (decoded && /[a-zA-Z]/.test(decoded)) {
        return decoded
      }
    } catch (e) {
      // 解码失败，返回原字符串
      return str
    }
  }
  return str
}

// 字符串排序（数字）
export const stringNumberSort = (a, b) => {
  if (parseInt(a) && parseInt(b)) {
    return a - b
  }
  // 分离每个字符串的前缀和数字部分
  const prefixA = a?.match(/[^0-9]+/g)?.[0]
  const prefixB = b?.match(/[^0-9]+/g)?.[0]
  const numA = a?.match(/[0-9]+/g)?.[0]
  const numB = b?.match(/[0-9]+/g)?.[0]
  // 首先比较前缀
  if (prefixA !== prefixB) {
    return prefixA?.localeCompare(prefixB)
  }
  // 如果前缀相同，则比较数字部分（将空字符串视为0）
  return parseInt(numA, 10) - parseInt(numB, 10)
}
